export const PIE_DATA_IDS = {
  backgroundArc: 'backgroundArc',
  metricArc: 'metricArc',
};
